import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function PremiumPartners() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const partners = [{
    id: 1,
    name: 'WIS IT-Solutions GmbH',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3YVWzeZQvSDdwEU1YPqYaj/wis_logo_freig_schwarz.png'
  }, {
    id: 2,
    name: 'autevis it & security solutions',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6V1qtsTVcXKrGT4Ruohwfw/logo-autevis.png'
  }
  // More partners can be added here in the future
  ];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === partners.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? partners.length - 1 : prevIndex - 1);
  };
  // Auto-slide functionality
  useEffect(() => {
    if (partners.length <= 1) return; // Don't auto-slide with only one partner
    const interval = setInterval(() => {
      nextSlide();
    }, 3000); // Change slide every 3 seconds
    return () => clearInterval(interval);
  }, [partners.length]);
  return <section id="premium-partner" className="py-16 bg-white" data-id="element-494">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-495">
        <div className="text-center" data-id="element-496">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-497">
            Premium Partner
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-498">
            Gemeinsam stark für sichere Zahnarztpraxen
          </p>
        </div>
        <div className="mt-12 text-center" data-id="element-499">
          <p className="text-lg text-gray-700 max-w-4xl mx-auto" data-id="element-500">
            Unsere zertifizierten Premium Partner sind ausgewählte IT- und
            Datenschutz-Experten, die den §390 SGB V Readiness Check gemeinsam
            mit uns anbieten. Sie erfüllen höchste Anforderungen an Qualität,
            Fachwissen und Verlässlichkeit und sind von neocube autorisiert, die
            Umsetzung direkt in den Praxen zu begleiten.
          </p>
        </div>
        <div className="mt-12 bg-blue-50 rounded-lg p-8 shadow-sm" data-id="element-501">
          <h3 className="text-xl font-semibold text-gray-900 mb-6 text-center" data-id="element-502">
            Was unsere Premium Partner auszeichnet:
          </h3>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-503">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-504">
              <h4 className="text-lg font-medium text-gray-900 mb-3" data-id="element-505">
                Spezialisierte Fachkenntnis
              </h4>
              <p className="text-gray-700" data-id="element-506">
                Alle Partner verfügen über nachweisliche Erfahrung in
                IT-Sicherheit, Datenschutz und branchenspezifischen Lösungen für
                Arzt- und Zahnarztpraxen.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-507">
              <h4 className="text-lg font-medium text-gray-900 mb-3" data-id="element-508">
                Geprüfte Prozessqualität
              </h4>
              <p className="text-gray-700" data-id="element-509">
                Jeder Partner arbeitet nach den Vorgaben der
                KZBV-IT-Sicherheitsrichtlinie (Stand Juli 2025) und nach unserem
                standardisierten Audit- und Umsetzungsprozess.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-510">
              <h4 className="text-lg font-medium text-gray-900 mb-3" data-id="element-511">
                Direkter Praxis-Support
              </h4>
              <p className="text-gray-700" data-id="element-512">
                Premium Partner sind berechtigt, Readiness Checks eigenständig
                durchzuführen, Maßnahmen umzusetzen und den Readiness-Nachweis
                inkl. Prüfprotokollen auszustellen.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16" data-id="element-513">
          <h3 className="text-xl font-semibold text-gray-900 mb-8 text-center" data-id="element-514">
            Unsere Premium Partner
          </h3>
          <div className="relative max-w-3xl mx-auto" data-id="element-515">
            {/* Logo Display */}
            <div className="overflow-hidden" data-id="element-516">
              <div className="flex items-center justify-center p-8 bg-white rounded-lg shadow-sm" data-id="element-517">
                {partners.length > 0 && <div className="transition-opacity duration-500 flex flex-col items-center" data-id="element-518">
                    <img src={partners[currentIndex].logo} alt={partners[currentIndex].name} className="h-auto object-contain" style={{
                  width: '200px'
                }} data-id="element-519" />
                  </div>}
              </div>
            </div>
            {/* Navigation arrows - only show if there's more than one partner */}
            {partners.length > 1 && <>
                <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 bg-white rounded-full p-2 shadow-md hover:bg-gray-100" data-id="element-520">
                  <ChevronLeftIcon className="h-6 w-6 text-gray-700" data-id="element-521" />
                </button>
                <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 bg-white rounded-full p-2 shadow-md hover:bg-gray-100" data-id="element-522">
                  <ChevronRightIcon className="h-6 w-6 text-gray-700" data-id="element-523" />
                </button>
              </>}
            {/* Dots indicator - only show if there's more than one partner */}
            {partners.length > 1 && <div className="flex justify-center mt-4 space-x-2" data-id="element-524">
                {partners.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 w-2 rounded-full ${index === currentIndex ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-525" />)}
              </div>}
          </div>
        </div>
      </div>
    </section>;
}